import {BASE_ACCOUNT_API, fetchAPI} from '@/services/api';
import {RequestPage, ResponsePage} from '@/services/page.interface';

// Minimal, extensible shape for AccountCompanyIndustry entries
export interface CompanyIndustry {
    industryId?: number;
    industryName?: string;
    industryChineseName?: string;
}

// Request payload for paging/filtering
export interface RequestCompanyIndustryPage extends RequestPage {
    industryName?: string;
}

// Client-side page container (if you want to store locally like CompanyList does)
export interface CompanyIndustryPage {
    records: CompanyIndustry[];
    total: number;
    pageNum: number;
    pageSize: number;
}

// Base path (adjust if backend differs)
const base = BASE_ACCOUNT_API + '/companyIndustry';

export async function getCompanyIndustry(industryId: number) {
    return fetchAPI<CompanyIndustry>(`${base}/${industryId}`);
}

// Accept legacy filters and normalize to { items, total }
export async function companySelectList() {
    return fetchAPI<{}>(`${base}/selectList`, {
        method: 'GET',
    });
}

export async function pageCompanyIndustries(payload?: RequestCompanyIndustryPage) {
    return fetchAPI<ResponsePage<CompanyIndustry>>(
        `${base}/queryPage`, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
}

export async function createCompanyIndustry(bo: CompanyIndustry) {
    return fetchAPI<CompanyIndustry>(`${base}/create`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function updateCompanyIndustry(industryId: number, bo: CompanyIndustry) {
    return fetchAPI<CompanyIndustry>(`${base}/update/${industryId}`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function deleteCompanyIndustry(industryId: number) {
    return fetchAPI<void>(`${base}/delete/${industryId}`, {method: 'POST'});
}
